const Footer = () => {
    return (
        <div className="flex h-20 text-lg justify-center items-center">
            Western University &copy; 2024 rights reserved.
        </div>
    );
};

export default Footer;
